import React, { useState, useRef, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, Button } from "@mui/material";
import { MainBg2 } from "./MainBg-2.js";
import { MainBg } from "./MainBg.jsx";
import Divider from '@mui/material/Divider';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { inputBgColor } from "./Scan";
import { enqueueSnackbar, closeSnackbar } from 'notistack';

import { newSessionUID, capitalize, decamelize, errorOptions, infoOptions, formatBytes, getApiUrl } from "./commons";
import { poolData, appf_tenant_info } from "../UserPool";

const failColor = "rgba(215, 57, 100, 1)";
const successColor = "rgba(71, 148, 72, 1)";

export const CheckLogo = ({ status, isDarkMode, unchecked = false }) => {
    let col1 = isDarkMode ? "white" : "black";
    let col2 = isDarkMode ? "black" : "white";

    if (status == "success") {
        col1 = successColor;
        col2 = "white";
    }
    else if (status == "error") {
        col1 = failColor;
        col2 = "white";
    }


    return <div
        style={{
            position: "absolute",
            left: -4,
            top: -3,
            width: 28,
            height: 28,
            marginLeft: 26,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill={unchecked ? "transparent" : col1} xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="11" fill={unchecked || status == "success" ? "transparent" : col1 } stroke={col1} opacity="0.98" />
            <path d="M9.5 13.59L7.41 11.5a1 1 0 10-1.41 1.41l3 3a1 1 0 001.41 0l6-6a1 1 0 10-1.41-1.41L10.5 13.59a1 1 0 01-1 0z" fill={status == "success"?col1:col2} />
        </svg>
    </div>
}

export const csvLogo = <svg
    width={21}
    height={21}
    viewBox="0 0 39 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path d="M35.9138 4H4V39H35.9138V4Z" stroke="currentColor" strokeWidth="0.52381" />
    <path d="M35.7266 10H4" stroke="currentColor" strokeWidth="0.52381" />
    <path d="M29.5174 7H27.4482" stroke="currentColor" strokeWidth="0.52381" />
    <path d="M32.9661 7H30.897" stroke="currentColor" strokeWidth="0.52381" />
    <path d="M26.0691 7H24" stroke="currentColor" strokeWidth="0.52381" />
    <path d="M18.4148 7H6" stroke="currentColor" strokeWidth="0.52381" />
    <path
        d="M16.0795 22H15.0227C14.9602 21.696 14.8509 21.429 14.6946 21.1989C14.5412 20.9688 14.3537 20.7756 14.1321 20.6193C13.9134 20.4602 13.6705 20.3409 13.4034 20.2614C13.1364 20.1818 12.858 20.142 12.5682 20.142C12.0398 20.142 11.5611 20.2756 11.1321 20.5426C10.706 20.8097 10.3665 21.2031 10.1136 21.723C9.86364 22.2429 9.73864 22.8807 9.73864 23.6364C9.73864 24.392 9.86364 25.0298 10.1136 25.5497C10.3665 26.0696 10.706 26.4631 11.1321 26.7301C11.5611 26.9972 12.0398 27.1307 12.5682 27.1307C12.858 27.1307 13.1364 27.0909 13.4034 27.0114C13.6705 26.9318 13.9134 26.8139 14.1321 26.6577C14.3537 26.4986 14.5412 26.304 14.6946 26.0739C14.8509 25.8409 14.9602 25.5739 15.0227 25.2727H16.0795C16 25.7187 15.8551 26.1179 15.6449 26.4702C15.4347 26.8224 15.1733 27.1222 14.8608 27.3693C14.5483 27.6136 14.1974 27.7997 13.8082 27.9276C13.4219 28.0554 13.0085 28.1193 12.5682 28.1193C11.8239 28.1193 11.1619 27.9375 10.5824 27.5739C10.0028 27.2102 9.54688 26.6932 9.21449 26.0227C8.8821 25.3523 8.71591 24.5568 8.71591 23.6364C8.71591 22.7159 8.8821 21.9205 9.21449 21.25C9.54688 20.5795 10.0028 20.0625 10.5824 19.6989C11.1619 19.3352 11.8239 19.1534 12.5682 19.1534C13.0085 19.1534 13.4219 19.2173 13.8082 19.3452C14.1974 19.473 14.5483 19.6605 14.8608 19.9077C15.1733 20.152 15.4347 20.4503 15.6449 20.8026C15.8551 21.152 16 21.5511 16.0795 22ZM22.56 21.4545C22.5089 21.0227 22.3015 20.6875 21.9379 20.4489C21.5742 20.2102 21.1282 20.0909 20.5998 20.0909C20.2134 20.0909 19.8754 20.1534 19.5856 20.2784C19.2987 20.4034 19.0742 20.5753 18.9123 20.794C18.7532 21.0128 18.6737 21.2614 18.6737 21.5398C18.6737 21.7727 18.729 21.973 18.8398 22.1406C18.9535 22.3054 19.0984 22.4432 19.2745 22.554C19.4506 22.6619 19.6353 22.7514 19.8285 22.8224C20.0217 22.8906 20.1992 22.946 20.3612 22.9886L21.2475 23.2273C21.4748 23.2869 21.7276 23.3693 22.006 23.4744C22.2873 23.5795 22.5558 23.723 22.8114 23.9048C23.07 24.0838 23.283 24.3139 23.4506 24.5952C23.6183 24.8764 23.7021 25.2216 23.7021 25.6307C23.7021 26.1023 23.5785 26.5284 23.3313 26.9091C23.087 27.2898 22.729 27.5923 22.2575 27.8168C21.7887 28.0412 21.2191 28.1534 20.5487 28.1534C19.9237 28.1534 19.3825 28.0526 18.9251 27.8509C18.4705 27.6491 18.1126 27.3679 17.8512 27.0071C17.5927 26.6463 17.4464 26.2273 17.4123 25.75H18.5032C18.5316 26.0795 18.6424 26.3523 18.8356 26.5682C19.0316 26.7812 19.2788 26.9403 19.5771 27.0455C19.8782 27.1477 20.2021 27.1989 20.5487 27.1989C20.9521 27.1989 21.3143 27.1335 21.6353 27.0028C21.9563 26.8693 22.2106 26.6847 22.3981 26.4489C22.5856 26.2102 22.6793 25.9318 22.6793 25.6136C22.6793 25.3239 22.5984 25.0881 22.4364 24.9062C22.2745 24.7244 22.0614 24.5767 21.7972 24.4631C21.533 24.3494 21.2475 24.25 20.9407 24.1648L19.8668 23.858C19.185 23.6619 18.6452 23.3821 18.2475 23.0185C17.8498 22.6548 17.6509 22.179 17.6509 21.5909C17.6509 21.1023 17.783 20.6761 18.0472 20.3125C18.3143 19.946 18.6722 19.6619 19.1211 19.4602C19.5728 19.2557 20.0771 19.1534 20.6339 19.1534C21.1964 19.1534 21.6964 19.2543 22.1339 19.456C22.5714 19.6548 22.918 19.9276 23.1737 20.2741C23.4322 20.6207 23.5685 21.0142 23.5827 21.4545H22.56ZM25.7976 19.2727L28.3885 26.6193H28.4908L31.0817 19.2727H32.1896L28.9851 28H27.8942L24.6896 19.2727H25.7976Z"
        fill="currentColor"
    />
</svg>



const avroLogo =
    <>
        {/*?xml version="1.0" standalone="yes"?*/}
        {/*
#
# Licensed to the Apache Software Foundation (ASF) under one
# or more contributor license agreements.  See the NOTICE file
# distributed with this work for additional information
# regarding copyright ownership.  The ASF licenses this file
# to you under the Apache License, Version 2.0 (the
# "License"); you may not use this file except in compliance
# with the License.  You may obtain a copy of the License at
#
#   https://www.apache.org/licenses/LICENSE-2.0
#
# Unless required by applicable law or agreed to in writing,
# software distributed under the License is distributed on an
# "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
# KIND, either express or implied.  See the License for the
# specific language governing permissions and limitations
# under the License.
#
*/}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width={21}
            height={21}
            viewBox="2 2 35 30"
        >
            <path
                fill="#0068e0"
                d="m 11.323019,20.31228 1.54227,4.70955 24.13142,6.882311 z"
            />
            <path
                fill="#000094"
                d="m 19.74759,12.513621 c 0.296701,1.17482 -0.0154,1.921136 -1.916568,1.736268 L 36.900852,31.9224 c 0.216248,0.08673 0.253906,-0.0582 0.104415,-0.279013 z"
            />
            <path
                fill="#1cccfc"
                d="m 19.141638,3.9863335 c 0,0 -0.680128,0.6419002 0.03537,1.4732323 0.530637,0.6173653 1.32431,0.2385015 1.32431,0.2385015 0,0 0.730909,-0.4102455 0.175738,-1.2752416 C 19.955281,3.297646 19.141638,3.9863335 19.141638,3.9863335 Z M 37.043496,31.999998 9.9901505,19.948822 c 0,0 -8.8393814,-5.467278 -7.923605,-7.626915 0.8918121,-2.090598 8.7703415,2.121979 9.6039545,2.315975 0.833613,0.195709 1.297493,-0.332076 1.312898,-0.700099 0.02454,-0.530637 -1.170253,-2.048375 -0.550607,-2.696551 0.617365,-0.646465 2.636637,0.612801 2.636637,0.612801 l 1.638127,1.134309 z"
            />
            <path
                fill="#1cccfc"
                d="M 37.150194,31.886453 19.297405,12.110222 c 0,0 -3.215773,-3.6511281 -3.082258,-4.6964268 0.133515,-1.0452988 4.404285,2.2914409 4.404285,2.2914409 0,0 0.474721,0.4570329 0.924906,0.3788639 0.450185,-0.07589 -0.03138,-0.8244852 -0.03138,-0.8244852 0,0 -0.737756,-1.7140161 -0.245348,-2.0215576 0.495261,-0.3052592 1.745396,0.9848175 1.745396,0.9848175 0,0 0.312105,0.3235177 0.639617,0.2362192 0.327511,-0.08901 0.151773,-0.8085089 0.151773,-0.8085089 0,0 -2.257774,-5.2065236 -1.272958,-5.5945166 1.50233,-0.5951128 3.641994,3.7133212 4.359781,5.0547499 0.180302,0.3703051 10.258977,24.7756347 10.258977,24.7756347 z M 9.2900523,7.4160775 c 0,0 -0.9157763,0.6065243 0.1027039,1.772215 0.9363168,1.0743985 1.7699308,0.5169436 1.7699308,0.5169436 0,0 0.864424,-0.5283551 0.03538,-1.5245842 C 10.101413,6.863758 9.2900523,7.4160775 9.2900523,7.4160775 Z"
            />
        </svg>
    </>

function FileComp({ processing,uploadID, isDarkMode = true, size, name, setFinalList, finalList }) {
    const myStatus = processing && processing[name]?.status || "" ;
    return <div
        key={name}
        style={{
            display: "flex",
            marginTop: 8,
            position: "relative",
        }}
        onClick={() => {
            setFinalList(prev => {
                let newVal = {
                    ...prev,
                    [name]: !prev[name]
                }

                return newVal
            })
        }}>

        <div style={{
            position: "absolute",
            left: 0,
            top: 0,
            width: 28,
            height: 28,
        }}>
            {name.endsWith(".csv") ? csvLogo : avroLogo}
        </div>

        <CheckLogo status={myStatus} isDarkMode={isDarkMode} unchecked={`${finalList[name]}` == `false`} />

        <div
           title={name.length > 80 ? name : ""}
            style={{
                display: "flex",
                marginTop: 5,
                marginLeft: 54,
                minWidth: "calc(100% - 120px)",
                color: myStatus == "error" ? failColor : (isDarkMode ? "white" : "black"),
            }}
        >
            {name?.length > 80 ? `${name.slice(0, 39)}...${name.slice(-38)}` : name}
       
        </div>
        <div
            style={{
                paddingTop:5,
                position: "relative",
                grow: 1,
                width: "100%",
                color: myStatus == "error" ? failColor : (isDarkMode ? "white" : "black"),
                justifyContent: "flex-end",
                textAlign: "right",
            }}
        >
            {formatBytes(size)}
        </div>
    </div>
}

export default function UploadAvroPage({ isDarkMode, setOpenUploadPage, openUploadPage, uploadAvroData, setUploadAvroData, uploadID }) {

    const [finalList, setFinalList] = useState({});

    useEffect(() => {
        setFinalList(
            ((uploadAvroData?.csvFiles?.concat(uploadAvroData?.avroFiles)) || [])
                .reduce((acc, aFile) => {
                    acc[aFile.name] = true;
                    return acc;
                }, {}) || {}
        )

        setUploadingInProgress(0);
    }, [uploadAvroData]);

    useEffect(() => {
        if (openUploadPage) {

        }
    }, [openUploadPage]);

    const [indexSetError, setIndexSetError] = useState(null);
    const [ processing,setProcessing] = useState(null);
    const [ uploadingInProgress,setUploadingInProgress] = useState(0);

    function closeAndClearData() {
        setUploadingInProgress(0);
        setUploadAvroData(null)
        setOpenUploadPage(false)
        setIndexSetError(null)
        setFinalList({})
        setProcessing(null)
    }

    let sizes = {
        width: 777,
        height: 640,
    }

    const buttonRef = useRef(null);


    return (
        <>
            <Dialog
                key={uploadID}
                id={uploadID}
                keepMounted
                style={{
                    overflow: "hidden",
                    padding: 0,
                    margin: 0,
                }}
                slotProps={{
                    paper: {
                        sx: {
                            color: isDarkMode ? "white" : "black",
                            opacity: 1,
                            overflow: "hidden",
                            padding: 0,
                            margin: 0,
                            minWidth: sizes.width,
                            minHeight: sizes.height,
                            background: "transparent !important"
                        }
                    }
                }}

                open={openUploadPage}
                onClose={() => {
                    closeAndClearData();
                }}>
                <div
                    style={{
                        zIndex: -1,
                        position: "absolute",
                        top: window.innerHeight < 800 ? window.innerHeight / 5.2 : 0,
                        marginTop: 0,
                        marginLeft: -26,
                        width: sizes.width + 26,
                        height: sizes.height + 12,
                        overflow: "hidden",
                        background: "transparent !important"
                    }}
                >
                    {/* <stop stopColor="#202020" /> */}
                    {/* <stop offset={1} stopColor="#321B17" /> */}

                    <MainBg col={"rgb(32,32,32)"} colEnd={"rgb(54,34,39)"} isDarkMode={isDarkMode} width={sizes.width + 50} height={sizes.height} ></MainBg>
                </div>

                <DialogTitle
                    style={{
                        paddingTop: window.innerHeight < 800 ? window.innerHeight / 4 : 60,
                        paddingLeft: 40,
                        // margin: 0,
                    }}
                >
                    <div
                        className="uploadProgressLog"
                        style={{
                            marginTop:-9,
                            right: 26,
                            position: "absolute",
                            maxHeight: 12,
                        }}>


                        <div className={"tolalScans"}>{processing && Object.keys(processing).length > 0 ? `${Object.keys(processing).length} /` : ""}
                            {finalList ? Object.keys(finalList).filter(f => finalList[f]).length : 0}<div>TOTAL</div></div>
                        {processing && Object.keys(processing).filter(f => processing[f].status == "error")?.length > 0 && <div className={"successScans"}>{processing && Object.keys(processing).filter(f => processing[f].status == "success")?.length } <div>SUCCESS</div></div>}
                        {processing && Object.keys(processing).filter(f => processing[f].status == "error")?.length > 0 && <div className={"failScans"}>{Object.keys(processing).filter(f => processing[f].status == "error")?.length ||""} <div>FAIL</div></div>}
                    </div>
                      
                    <div style={{
                        fontSize: 16,
                        marginTop: -14
                    }}>
                        Upload AVRO or CSV
                    </div>
                    <div style={{
                        fontSize: 13,
                        opacity: 0.5,
                        marginBottom: 32
                    }}>
                        Select/deselect files to upload.
                    </div>

                </DialogTitle>
                <DialogContent
                    sx={{
                        padding: 0,
                        paddingLeft: "40px",
                        paddingRight: "40px",
                        margin: 0,
                        marginTop: "-40px",
                        maxWidth: "700px",
                    }}
                >

                    <div style={{
                        position: "absolute",
                        zIndex: 100,
                        marginTop: -8,
                        fontSize: 11,
                        width: "calc(100% - 80px)",
                        height: 42,
                        color: failColor,

                        opacity: indexSetError ? 1 : 0,
                    }}>{indexSetError}</div>


                    <div style={{
                        scrollbarWidth: "thin",
                        scrollbarColor: "var(--assess-scrollbar-thumb) rgba(0,0,0,0)", overflow: "scroll",
                        position: "relative",
                        zIndex: 9999999,
                        minHeight: 350,
                        maxHeight: 350,
                        marginTop: 20,
                        marginBottom: 20,
                        padding: 10,
                        backgroundColor: inputBgColor(isDarkMode),
                        borderRadius: 4,
                        opacity: 1,
                        fontSize: 12,
                    }}>
                        {
                            finalList && Object.keys(finalList).length > 2 &&
                        <div
                            style={{
                                position: "relative",
                                left: 0,
                                top: 0,
                                width: 22,
                                height: 22,
                            }}
                            onClick={() => {
                                let allSelected = Object.keys(finalList).every(f => finalList[f]);
                                let noneSelected = Object.keys(finalList).every(f => finalList[f] == false);
                                let anySelected = Object.keys(finalList).some(f => finalList[f]);
                                if (allSelected) {
                                    setFinalList(prev => {
                                        return Object.keys(prev).reduce((acc, f) => {
                                            acc[f] = false;
                                            return acc;
                                        }, {});
                                    });
                                } else if (anySelected) {
                                    setFinalList(prev => {
                                        return Object.keys(prev).reduce((acc, f) => {
                                            acc[f] = true;
                                            return acc;
                                        }, {});
                                    });
                                } else {
                                    if (noneSelected) {
                                        setFinalList(prev => {
                                            return Object.keys(prev).reduce((acc, f) => {
                                                acc[f] = true;
                                                return acc;
                                            }, {});
                                        });
                                    }
                                }
                            }}>
                            <CheckLogo isDarkMode={isDarkMode} unchecked={`${Object.keys(finalList).every(f => finalList[f]) === true}` == `false`} />
                        </div>
                        }
                        {
                            (uploadAvroData?.csvFiles?.length > 0 || uploadAvroData?.avroFiles?.length > 0) &&
                            <>
                                {
                                    uploadAvroData.csvFiles.map(csvFile => {
                                        return <FileComp processing={processing} uploadID={uploadID} isDarkMode={isDarkMode} key={csvFile.name} size={csvFile.size} name={csvFile.name} finalList={finalList} setFinalList={setFinalList} />

                                    })
                                }
                                {
                                    uploadAvroData.avroFiles.map(avroFile => {
                                        return <FileComp processing={processing} uploadID={uploadID} isDarkMode={isDarkMode} key={avroFile.name} size={avroFile.size} name={avroFile.name} finalList={finalList} setFinalList={setFinalList} />
                                    })
                                }
                            </>
                        }
                    </div>
                    <div style={{
                        overflow: "hidden",
                        position: "absolute",
                        marginTop: -10,
                        marginLeft: 220,
                        // bottom: 4,
                        width: "calc(100% - 220px)",
                        height: "180px",
                        overflow: "hidden",
                    }}>
                        <Button
                            id="saveSettingsButton"
                            ref={buttonRef}
                            disabled={
                                (finalList ? (Object.keys(finalList || {}).filter(f => finalList[f]) || []) : []).length === 0
                            }
                            style={{
                                color: isDarkMode ? "rgba(255,255,255,0.75)" : "rgba(0,0,0,0.5)",
                                fontSize: 14,
                                marginTop: 24,
                                opacity: (finalList ? (Object.keys(finalList || {}).filter(f => finalList[f]) || []) : []).length === 0 ? 0.242 : 1,
                                maxWidth: 148,
                                minWidth: 148,
                                maxHeight: 32,
                                minHeight: 22,
                                padding: "4px !important",
                                borderRadius: 4,
                                border: isDarkMode ? "1px solid rgba(42,42,42,0)" : "1px solid rgba(0,0,0,0.142)",
                            }}
                            onClick={(event) => {
                                
                                if(uploadingInProgress == 1){
                                    return;
                                }

                                if(uploadingInProgress == 2){
                                    let csvFiles = []
                                    let avroFiles = []

                                    try{
                                       csvFiles = uploadAvroData?.csvFiles.filter(f => processing[f.name]?.status == "error");
                                    }catch(e){}
                                    try{
                                        avroFiles = uploadAvroData?.avroFiles.filter(f => processing[f.name]?.status == "error");
                                    }catch(e){}

                                    if(csvFiles.length > 0 || avroFiles.length > 0){
                                        setUploadAvroData(p=>{
                                            return {
                                                ...p,
                                                csvFiles: csvFiles,
                                                avroFiles: avroFiles
                                            }
                                        });
                                    }else{
                                       closeAndClearData(); 
                                    }
                                }

                                let allFiles  = uploadAvroData?.csvFiles?.concat(uploadAvroData?.avroFiles) || [];
                                let allFailures = [];


                                try{
                                    allFailures = processing ? Object.keys(processing).filter(f => processing[f].status == "error") : [];
                                }catch(e){

                                }

                                if( allFailures.length > 0 ){
                                    //this is retry logic, remove successful
                                    allFiles = allFiles.filter(f => allFailures.includes(f.name));
                                }


                                async function uploadPutOperation(u) {                                    
                                    let apiUrl = getApiUrl(poolData.envURL);
                                    let scanResultsAPI = `${apiUrl}/upload/scan-results`;

                                    try {
                                        // window._g.accT is only ever set for the Amplify notifications
                                        // token provider (App.js, gated on notificationsEnabled + cognito
                                        // auth) — not a reliable source of "the current token". Mirror the
                                        // exact fallback chain the working GraphQL ApolloLink uses
                                        // (UserPool.js) instead: poolData.accessToken defaults to
                                        // localStorage.token || "" and is only populated by refreshToken(),
                                        // so when that hasn't happened yet the real live token is in
                                        // appf_tenant_info.session.accessToken.
                                        try { poolData.refreshToken(); } catch (e) { /* */ }
                                        let accT = poolData.accessToken;
                                        if (!accT || accT.length === 0) {
                                            try { accT = appf_tenant_info.session.accessToken; } catch (e) { /* */ }
                                        }
                                        if (!accT) { accT = window?._g?.accT; }

                                        // Ask the uploader for a presigned S3 URL rather than proxying
                                        // the bytes through it - the byte-proxy path is capped by
                                        // Lambda's ~4.5MB synchronous invoke limit (after base64
                                        // inflation), while a direct-to-S3 PUT via presigned URL is
                                        // only bounded by S3's own 5GB single-PUT limit. Accept:
                                        // application/json opts into the JSON {url} response - the
                                        // endpoint's default is a 308 redirect, kept for other callers.
                                        const presignResponse = await fetch(`${scanResultsAPI}/${window.currentProjectId}/${window.currentSEnv}/${u.name}`, {
                                            method: 'POST',
                                            headers: {
                                                'Authorization': `Bearer ${accT}`,
                                                'Accept': 'application/json',
                                                "X-Project-Id": `${window.currentProjectId}`,
                                                "X-Environment-Id": `${window.currentSEnv}`
                                            }
                                        });

                                        if (!presignResponse.ok) {
                                            let errorText = await presignResponse.text();
                                            errorText = presignResponse.status + " - " + errorText;
                                            setIndexSetError(p => ((p ? p + " - " : "") + (errorText)));
                                            setProcessing(p => ({
                                                ...p,
                                                [u.name]: { status: "error", error: presignResponse.statusText }
                                            }));
                                            return { name: u.name, ok: false };
                                        }

                                        const { url: presignedUrl } = await presignResponse.json();

                                        // No Authorization/X-Project-Id/X-Environment-Id here - this
                                        // goes straight to S3, not through Kong/the lambda. Auth is
                                        // embedded in the presigned URL's own signature.
                                        const response = await fetch(presignedUrl, {
                                            method: 'PUT',
                                            body: u.data
                                        });

                                        if (!response.ok){
                                            let errorText =  await response.text();

                                            try{
                                                let jsonData = JSON.parse(errorText);
                                                errorText = jsonData.message;
                                            }catch(e){
                                                // console.log(e);
                                            }

                                            errorText = response.status +  " - " + errorText;
                                            setIndexSetError( errorText ); // leave only last error 
                                            setProcessing(p=>{

                                                return {
                                                    ...p,
                                                    [u.name]: {
                                                        status: "error",
                                                        error: response.statusText
                                                    }
                                                }

                                            });
                                            return { name: u.name, ok: false };
                                        }else{
                                            // The upload endpoint isn't guaranteed to return a JSON
                                            // body (e.g. a 201 with an empty body) — don't let a parse
                                            // failure here misreport a successful upload as failed.
                                            try { await response.json(); } catch (e) { /* no/non-JSON body, ignore */ }
                                            setProcessing(p=>{
                                                return {
                                                    ...p,
                                                    [u.name]: { status: "success" }
                                                }
                                            });
                                            return { name: u.name, ok: true };
                                        }
                                    } catch (e) {
                                        setIndexSetError(p=> ((p?p +" - ":"")+(`${u.name} - ${e.message}`)) );
                                        setProcessing(p=>{
                                            return {
                                                ...p,
                                                [u.name]: { status: "error", error: e.message }
                                            }
                                        });
                                        return { name: u.name, ok: false };
                                    }
                                }
                                setIndexSetError(null);

                                let uploadingFilesProgress = ( allFiles || []).filter(f => {
                                    return finalList[f.name] == true && !(processing? processing[f.name]?.status == "success":false );
                                })


                                setProcessing({});
                                setUploadingInProgress(1);
                                Promise.all(uploadingFilesProgress.map(u => uploadPutOperation(u))).then(results => {
                                    if( results.length > 0) {
                                        setUploadingInProgress(2);
                                    }
                                    
                                    const succeeded = results.filter(r => r.ok);
                                    const failed = results.filter(r => !r.ok);

                                    if (succeeded.length) {
                                        enqueueSnackbar(
                                            `Uploaded ${succeeded.length} file${succeeded.length > 1 ? "s" : ""} successfully`,
                                            infoOptions
                                        );
                                    }
                                    if (failed.length) {
                                        enqueueSnackbar(
                                            `Failed to upload ${failed.length} file${failed.length > 1 ? "s" : ""}`,
                                            errorOptions
                                        );
                                    } else {
                                        closeAndClearData();
                                    }
                                });

                                

                            }}>
                                {/* uploadingInProgress:
                                   -  0 initial state - waiting for selections
                                   -  1 uploading in progress
                                   -  2 uploading all files done
                                   */}
                                   
                                { (uploadingInProgress == 1)? <div style={{ fontSize: 12, marginRight: 10 }}>Uploading...</div>
                                : uploadingInProgress == 2?
                                ((Object.keys(processing || {}).filter(f => processing[f].status == "error")  || []).length > 0 ?
                                  <div>Retry failed</div>
                                  :
                                  <div>Close</div>)
                                :
                                uploadingInProgress == 0?(
                                <div>Upload
                                    <>
                                    {(finalList ? (Object.keys(finalList || {}).filter(f => finalList[f]) || []) : []).length>1 &&
                                    <>
                                    &nbsp;({(finalList ? (Object.keys(finalList || {}).filter(f => finalList[f]) || []) : []).length})&nbsp;file{(finalList ? (Object.keys(finalList || {}).filter(f => finalList[f]) || []) : []).length > 1 ? "s" : ""}
                                    </>
                                }
                                </>
                                </div>):
                                <div>OK</div>
                                }
                                </Button>

                        <Button
                            style={{
                                color: isDarkMode ? "rgba(255,255,255,0.75)" : "rgba(0,0,0,0.5)",
                                fontSize: 14,
                                marginTop: 24,
                                marginLeft: 20,
                                maxWidth: 128,
                                minWidth: 128,
                                maxHeight: 32,
                                minHeight: 22,
                                padding: "4px !important",
                                borderRadius: 4,
                                border: isDarkMode ? "1px solid rgba(42,42,42,0)" : "1px solid rgba(0,0,0,0.142)",
                            }}
                            onClick={(event) => {
                                closeAndClearData();
                            }}>CANCEL</Button>
                    </div>
                </DialogContent>

            </Dialog>
        </>

    )
}

export { UploadAvroPage };